/**
 * Project file sources that can be attached when a phase email trigger fires.
 * Resolved on the API from acf_groups_json + project_field_files.
 */

export const EMAIL_TRIGGER_ATTACHMENT_SOURCES = [
  {
    id: "fiber_dlr",
    label: "Fiber — DLR files",
    description: "DLR from each row in Fiber files",
    defaultForTriggers: ["fiber_complete"],
  },
  {
    id: "fiber_otdr",
    label: "Fiber — OTDR files",
    description: "OTDR from each row in Fiber files",
    defaultForTriggers: [],
  },
  {
    id: "construction_asbuilt",
    label: "Construction — As-built",
    description: "As-built uploads on the Construction section",
    defaultForTriggers: ["construction_complete"],
  },
  {
    id: "construction_usa_ticket",
    label: "Construction — USA ticket",
    description: "USA ticket files on the Construction section",
    defaultForTriggers: [],
  },
  {
    id: "networking_cut_sheet",
    label: "Networking — Cut sheet",
    description: "Cut sheet on the Networking section",
    defaultForTriggers: ["networking_complete"],
  },
  {
    id: "networking_topology",
    label: "Networking — Topology",
    description: "Topology PDF on the Networking section",
    defaultForTriggers: [],
  },
  {
    id: "networking_nid_config",
    label: "Networking — NID config",
    description: "NID config on the Networking section",
    defaultForTriggers: [],
  },
  {
    id: "summary_signed_work_order",
    label: "Summary — Signed / service order",
    description: "Signed work order or service order PDF on Project summary",
    defaultForTriggers: ["new_work_order"],
  },
];

export const EMAIL_TRIGGER_ATTACHMENT_SOURCE_IDS = new Set(
  EMAIL_TRIGGER_ATTACHMENT_SOURCES.map((s) => s.id)
);

export function defaultAttachmentSourcesForTrigger(triggerId) {
  return EMAIL_TRIGGER_ATTACHMENT_SOURCES.filter((s) =>
    (s.defaultForTriggers || []).includes(triggerId)
  ).map((s) => s.id);
}
